module.exports = __webpack_public_path__ + "img/common_cart.b7c52f82.png";